import { render, staticRenderFns } from "./Page-Registration.vue?vue&type=template&id=9d221522&"
import script from "./Page-Registration.vue?vue&type=script&lang=js&"
export * from "./Page-Registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports